module.exports = __webpack_public_path__ + "img/avatar-tall.6356da43.png";